import { useEffect } from 'react';
import Text from 'components/base/Text';
import { SelectStateFieldSection } from './SelectStateFieldSection';
import { CFR_INCIDENT_STRATEGY } from '@linearb/linjs-common';
import { LBLabel, LBRadioGroup, LBRadioGroupItem } from '@linearb/buzz';

const StateTransitionLabel = () => {
  return (
    <Text size='medium'>Start tracking bugs with state "In Progress"</Text>
  );
};

export const IncidentValidation = ({
  items,
  selectedStrategy,
  selectedItem,
  setSelectedItem,
  setSelectedStrategy
}) => {
  useEffect(() => {
    if (!!selectedItem) {
      setSelectedStrategy(CFR_INCIDENT_STRATEGY.CUSTOM_FIELD);
    }
  }, [selectedItem]);

  return (
    <div
      className='flex flex-col pt-8'
      data-cy='incident-validation-settings-section'
    >
      <Text size='medium' weight='bold'>
        INCIDENT VALIDATION
      </Text>
      <div className='flex flex-col pt-4'>
        <LBRadioGroup
          onValueChange={setSelectedStrategy}
          value={selectedStrategy}
        >
          <div className='flex flex-row items-center gap-2'>
            <LBRadioGroupItem
              value={CFR_INCIDENT_STRATEGY.STATE}
              id={CFR_INCIDENT_STRATEGY.STATE}
              data-testid='state-transition-option'
            />
            <LBLabel htmlFor={CFR_INCIDENT_STRATEGY.STATE}>
              <StateTransitionLabel />
            </LBLabel>
          </div>
          <div className='flex flex-row items-center gap-2'>
            <LBRadioGroupItem
              value={CFR_INCIDENT_STRATEGY.CUSTOM_FIELD}
              id={CFR_INCIDENT_STRATEGY.CUSTOM_FIELD}
              data-testid='custom-field-transition-option'
            />
            <LBLabel htmlFor={CFR_INCIDENT_STRATEGY.CUSTOM_FIELD}>
              <SelectStateFieldSection
                title='From date and time field'
                itemsList={items}
                buttonTitle='Select custom field'
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
              />
            </LBLabel>
          </div>
        </LBRadioGroup>
      </div>
    </div>
  );
};
